module.exports = __webpack_public_path__ + "img/AD_page_01.3833ee8c.jpg";